import React, { useState } from 'react';
import { IntlShape } from 'react-intl';
import styled from 'styled-components';
import { get, isEmpty, isNil } from 'lodash';
import { toast } from 'react-toastify';
import ClaimInformation from 'containers/PreOpeningPage/ClaimInformation';
import ClaimCircumstances from 'containers/PreOpeningPage/ClaimCircumstances';
import ClaimDeclaration from 'containers/PreOpeningPage/ClaimDeclaration';
import VictimCard from 'containers/PreOpeningPage/VictimCard';
import UploadDocumentsBloc from 'containers/RecapPage/uploadDocumentsBloc';
import DialogFeeNote from 'components/DialogFeeNote';
import { filterFeeNotes } from 'containers/CourtManagerLegalProceedings/utils';
import { Listings } from 'containers/AppContainer/typings';
import {
  CLAIM_STATUS,
  EMPTY_CLAIM_TO_PREOPEN,
  PROCEDURE_STATUSES,
  VICTIM,
} from 'containers/data-structure';
import DecisionComponent from 'containers/RecapManagerPage/DecisionComponent';
import { KeycloakUser } from 'containers/RecapManagerPage/typings';
import OpposingPartyRecapContainer from 'containers/PreOpeningPage/OpposingParty/OpposingPartyRecapContainer';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import FraudeInformation from 'containers/PreOpeningPage/fraude';
import { isOpeningManager } from 'containers/AppContainer/utils';
import userPrivileges, {
  userHasPrivilege,
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { BUTTON_COLORS } from 'constants/design';
import { translate } from 'containers/services/translate';
import messages from 'containers/LawyerRecapPage/messages';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import {
  EMPTY_SUPPORT_DOC,
  PV_DOC_ID,
} from 'containers/LawyerRecapPage/constants';
import { CorporealDocument } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import LawyerClaimCircumstances from 'containers/LawyerRecapPage/LawyerClaimCircumstances';
import CoreButton from 'components/Buttons/CoreButton';
import ProvisionIntervenantDialog from 'containers/RecapManagerPage/ProvisionIntervenantDialog';
import { resolveSagisClaim } from 'helpers/utils';
import { rcCoporeal } from 'containers/CourtManagerLegalProceedings/constants';
import { formatOpposingParties } from 'containers/CourtManagerLegalProceedings/utils';
import {
  CHOICE,
  INJURY_POST_DECEASED,
} from 'containers/PreOpeningPage/constants';
import { extractOpposingParties } from 'containers/PreOpeningPage/utils';
import { MANAGEMENT_MODES } from 'containers/RecapManagerPage/constants';
import { PROFESSION_CODES } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import { useSelector } from 'react-redux';
import {
  addPriorityReasonProfession,
  removeRejectedVictims,
} from 'services/utils';
import { VictimType } from 'typings/globalTypes';
import { ClaimRecapType } from 'typings/claimTypes';

export interface ClaimRecapProps {
  intl: IntlShape;
  listings: Listings;
  storedClaimToPreopen: any;
  claimId: number;
  requestClaimRecap: Function;
  match: { params: { claimId: number } };
  claimRecap: ClaimRecapType;
  policyInfo: { sagis: {} };
  requestSearchClaims: Function;
  resetSearchClaimsStore: Function;
  setClaimRecap: Function;
  requestRejectClaim: Function;
  requestOpenClaim: Function;
  requestAssigment: Function;
  requestCorporealLawyers: Function;
  requestOpenMixedClaim: Function;
  corporealLawyers: KeycloakUser[];
  openedClaim: any;
  requestUpdateVictimInfo?: Function;
  requestCreateVehicle?: Function;
  requestValidateVictim?: Function;
  requestValidateVehicle: Function;
  requestAddVictims?: Function;
  requestUpdateVehicleInfo: Function;
  requestUpdateClaim?: Function;
  resetUploadDocumentStore?: Function;
  uploadDocument?: Function;
  uploadedDocument: IUploadedDocument;
  setDocumentId?: Function;
  documentId: string;
  requestAddDocumentClaim?: Function;
  requestValidateProvisionIntervenant?: Function;
  requestUnlockClaim: Function;
  requestLockClaim: Function;
  setLockedClaim: Function;
  resetStoreClaim: Function;
  foundClaims: any;
  requestAddClaimNumber: Function;
  feeNotes: any;
  loaders: any;
  requestGetFeeNotesByClaimId: Function;
  allFeeNote: any;
  feeNotesCount: any;
  linkToBeneficiaryCodes: any;
  requestAddInvoiceFeeNote: Function;
  makeDecisionFeeNote: Function;
  requestFeeNoteExceptionalCosts: Function;
  requestAllFeeNotes: Function;
  requestUpdateFeeNoteAmount: Function;
  requestUpdateFeeNoteStatus: Function;
  requestUpdateInvoiceFeeNote: Function;
  requestCreateFeeNote: Function;
  requestFeeNotesByClaimNumb: Function;
  dataClaimToUpdate: any;
  setDataClaimToUpdate: Function;
  requestGetReportsPolicy: Function;
  requestGetDocByDocumentumId: Function;
  requestUpdateFirmReferenceManager: Function;
}

const Container = styled.div`
  &&.titleContainer {
    display: flex;
    margin-top: 50px;
    margin-bottom: 10px;
  }
  .title {
    width: 180px;
    text-align: left;
    font-family: Roboto;
    letter-spacing: 0;
    color: #2b2727;
    opacity: 1;
    font-size: 24px;
    margin-top: 63px;
  }
  .validationButton {
    float: right;
  }
`;

const GlobalBloc = styled.div`
  &&.globalBloc {
    position: relative;
  }
`;
export const StyledButton = styled(CoreButton)`
  margin-top: 10px;
  margin-bottom: 20px;
  width: 300px;
  height: 40px;
  background: #ffc912;
  &:hover {
    background-color: #ffc912;
  }
`;
export const ClaimRecap: React.FC<ClaimRecapProps> = (props): JSX.Element => {
  const [openFeeNoteDialog, setOpenFeeNoteDialog] = React.useState<boolean>(
    false,
  );
  const [
    isProvisionIntervenantDialogOpen,
    setIsProvisionIntervenantDialogOpen,
  ] = useState<boolean>(false);

  const handleClose = () => {
    setOpenFeeNoteDialog(false);
  };
  const [page, setPage] = React.useState<number>(0);

  const getClaimNumber = () => {
    const claim = get(props.claimRecap, 'claim', {});
    return get(claim, 'claimNumber', '');
  };

  const successCallback = () => {
    toast.success(translate(messages.validationSuccessMessage, props));
  };

  const [updatedPVDocument, setUpdatedPVDocument] = useState({
    ...EMPTY_SUPPORT_DOC,
  });

  const deletePVDocument = (document: CorporealDocument) => {
    setUpdatedPVDocument({ ...EMPTY_SUPPORT_DOC });
  };

  const setDocument = (document: CorporealDocument) => {
    if (props.requestAddDocumentClaim)
      props.requestAddDocumentClaim({
        ...document,
        claimId: props.match.params.claimId,
        claimNumber: getClaimNumber(),
        isInboxesActive: featureService.hasFeature(
          FEATURES.ATTRIBUTION_INBOXES_MANAGER,
        ),
      });
    if (props.resetUploadDocumentStore) props.resetUploadDocumentStore();
    props.requestClaimRecap(props.claimId);
  };

  const priorityReasonClaimId = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap', 'claim', 'priorityReasonId']),
  );

  const updatePriorityVictim =
    !removeRejectedVictims(
      get(props.claimRecap, 'victims', []),
    ).find((v: any) => PROFESSION_CODES.includes(v.professionCode)) &&
    priorityReasonClaimId === 5;

  const setPVDocument = (document: CorporealDocument) => {
    if (props.documentId === PV_DOC_ID) {
      setUpdatedPVDocument(document);
      if (props.resetUploadDocumentStore) props.resetUploadDocumentStore();
    }
  };

  const provisionIntervenants =
    props.policyInfo &&
    get(resolveSagisClaim(props.policyInfo), 'contractorFees', []);

  const riskId =
    props.policyInfo &&
    get(resolveSagisClaim(props.policyInfo), 'offeredRisks', []).find(
      (element: { riskName: string }) => element.riskName === rcCoporeal,
    )?.riskId;

  const formattedSagisVictims = [...get(props.dataClaimToUpdate, 'victims', [])]
    .filter((v: any) => !v.isDeleted && !v.id)
    .map((victim: VictimType) => {
      let setDefaultBirthDate = false;
      if (isEmpty(victim[VICTIM.DATE_OF_BIRTH])) {
        setDefaultBirthDate = true;
      }
      return {
        ...victim,
        id: undefined,
        victimFirstName: victim[VICTIM.FIRST_NAME],
        victimLastName: victim[VICTIM.LAST_NAME],
        victimBirthDate: victim[VICTIM.DATE_OF_BIRTH],
        injuryCode:
          String(victim[VICTIM.INJURY_POST_KEY]) === INJURY_POST_DECEASED
            ? victim[VICTIM.INJURY_POST_KEY]
            : 0,
        qualityVictim: victim[VICTIM.QUALITY_KEY],
        classVictim: victim[VICTIM.CLASS_KEY],
        Town: victim[VICTIM.CITY],
        isExcluded: false,
        cspCode: get(
          get(props.listings, 'Profession', []).find(
            (el: any) => el.ItemKey === victim.professionCode,
          ),
          'ItemGroup',
          null,
        ),
        gender: !isNil(victim[VICTIM.GENDER]) ? victim[VICTIM.GENDER] : '',
        Complement: victim[VICTIM.ADDRESS],
        isWorkAccident: victim[VICTIM.WORK_ACCIDENT_ID] === 1 ? true : false,
        setDefaultBirthDate,
        itt: parseInt((victim[VICTIM.ITT] as unknown) as string),
      };
    });

  const formattedSagisVictimsToUpdate = [
    ...get(props.dataClaimToUpdate, 'victims', []),
  ]
    .filter((v: any) => v.isModified && v.id)
    .map((victim: VictimType) => {
      let setDefaultBirthDate = false;
      if (isEmpty(victim[VICTIM.DATE_OF_BIRTH])) {
        setDefaultBirthDate = true;
      }
      return {
        ...victim,
        victimFirstName: victim[VICTIM.FIRST_NAME],
        victimLastName: victim[VICTIM.LAST_NAME],
        victimBirthDate: victim[VICTIM.DATE_OF_BIRTH],
        injuryCode:
          String(victim[VICTIM.INJURY_POST_KEY]) === INJURY_POST_DECEASED
            ? victim[VICTIM.INJURY_POST_KEY]
            : 0,
        qualityVictim: victim[VICTIM.QUALITY_KEY],
        classVictim: victim[VICTIM.CLASS_KEY],
        Town: victim[VICTIM.CITY],
        isExcluded: false,
        cspCode: get(
          get(props.listings, 'Profession', []).find(
            (el: any) => el.ItemKey === victim.professionCode,
          ),
          'ItemGroup',
          null,
        ),
        gender: !isNil(victim[VICTIM.GENDER]) ? victim[VICTIM.GENDER] : '',
        Complement: victim[VICTIM.ADDRESS],
        isWorkAccident: victim[VICTIM.WORK_ACCIDENT_ID] === 1,
        setDefaultBirthDate,
        itt: parseFloat((victim[VICTIM.ITT] as unknown) as string),
      };
    });

  const beneficiariesToDelete = [...get(props.dataClaimToUpdate, 'victims', [])]
    .filter((v: any) => v.injuryPostKey === INJURY_POST_DECEASED)
    .map((victim: VictimType) => {
      let beneficiaries = get(victim, 'beneficiariesToDelete', []).map(
        (el: any) => el.nextOfKinKey,
      );
      return beneficiaries;
    });

  const formattedSagisVehiculesToUpdate = get(
    props.dataClaimToUpdate,
    'vehicules',
    [],
  )
    .filter((v: any) => v.isModified && v.id)
    .map((vehicule: any) => {
      return {
        ...vehicule,
        insuranceCompanyCode: vehicule?.opposingParty,
        partyKey: vehicule?.partyKey,
        riskID: riskId,
      };
    });

  return (
    <GlobalBloc className="globalBloc">
      {userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER) && (
        <DecisionComponent
          listings={props.listings}
          requestSearchClaims={props.requestSearchClaims}
          claimId={props.match.params.claimId}
          claimRecap={props.claimRecap}
          requestRejectClaim={props.requestRejectClaim}
          requestOpenClaim={props.requestOpenClaim}
          requestAssigment={props.requestAssigment}
          policyInfo={props.policyInfo}
          requestCorporealLawyers={props.requestCorporealLawyers}
          corporealLawyers={props.corporealLawyers}
          requestOpenMixedClaim={props.requestOpenMixedClaim}
          openedClaim={props.openedClaim}
          dataClaimToUpdate={props.dataClaimToUpdate}
          setOpenFeeNoteDialog={setOpenFeeNoteDialog}
        />
      )}
      {featureService.hasFeature(FEATURES.FEE_NOTE) &&
        !isEmpty(props.feeNotes) && (
          <DialogFeeNote
            allFeeNote={props.allFeeNote}
            requestAllFeeNotes={props.requestAllFeeNotes}
            feeNotes={filterFeeNotes(props.feeNotes, false, {}, false)}
            feeNotesCount={props.feeNotesCount}
            requestLawyerFeeNotes={props.requestFeeNotesByClaimNumb}
            requestCreateFeeNote={props.requestCreateFeeNote}
            requestFeeNoteCosts={props.requestFeeNoteExceptionalCosts}
            keyclokToken={null}
            resetUploadDocumentStore={
              props.resetUploadDocumentStore
                ? props.resetUploadDocumentStore
                : () => {}
            }
            uploadDocument={
              props.uploadDocument ? props.uploadDocument : () => {}
            }
            uploadedDocument={props.uploadedDocument}
            setDocumentId={props.setDocumentId ? props.setDocumentId : () => {}}
            documentId={props.documentId}
            makeDecisionFeeNote={props.makeDecisionFeeNote}
            open={openFeeNoteDialog}
            handleClose={handleClose}
            showButtonAdd={false}
            title={translate(messages.FeeNoteTitle, props)}
            claimNumber={get(props.claimRecap, 'claim.claimNumber')}
            listings={props.listings}
            page={page}
            setPage={setPage}
            linkToBeneficiaryCodes={props.linkToBeneficiaryCodes}
            isExpert={false}
            requestUpdateFeeNoteAmount={props.requestUpdateFeeNoteAmount}
            loaders={props.loaders}
            requestAddInvoiceFeeNote={props.requestAddInvoiceFeeNote}
            requestUpdateInvoiceFeeNote={props.requestUpdateInvoiceFeeNote}
            requestUpdateFeeNoteStatus={props.requestUpdateFeeNoteStatus}
            contractorFeesSagis={[]}
            isConsultation={false}
            requestUpdateFirmReferenceManager={
              props.requestUpdateFirmReferenceManager
            }
          />
        )}
      {!isEmpty(props.claimRecap) && !isEmpty(props.policyInfo) && (
        <Container>
          <ClaimDeclaration
            isRecapPage
            isManager
            isReadOnly={false}
            inputProps={{ disableUnderline: true }}
            disableInput
            inputLabelProps
            listings={props.listings}
            claimToPreopen={EMPTY_CLAIM_TO_PREOPEN}
            storedClaimToPreopen={props.claimRecap}
            policyInfo={props.policyInfo}
            setClaimRecap={props.setClaimRecap}
            isOpeningManager={userPrivileges.userHasPrivilege(
              PRIVILEGES.ISOPENINGMANAGER,
            )}
            setDataClaimToUpdate={props.setDataClaimToUpdate}
            dataClaimToUpdate={props.dataClaimToUpdate}
            requestClaimRecap={props.requestClaimRecap}
          />
          <ClaimInformation
            isRecapPage
            isManager
            isReadOnly={false}
            inputProps={{ disableUnderline: true }}
            disableInput
            inputLabelProps
            listings={props.listings}
            claimToPreopen={EMPTY_CLAIM_TO_PREOPEN}
            storedClaimToPreopen={props.claimRecap}
            policyInfo={props.policyInfo}
            setClaimRecap={props.setClaimRecap}
            stakeholders={[]}
            isOpeningManager={userPrivileges.userHasPrivilege(
              PRIVILEGES.ISOPENINGMANAGER,
            )}
            setDataClaimToUpdate={props.setDataClaimToUpdate}
            dataClaimToUpdate={props.dataClaimToUpdate}
            requestSearchClaims={props.requestSearchClaims}
            foundClaims={props.foundClaims}
            requestClaimRecap={props.requestClaimRecap}
          />
          {featureService.hasFeature(FEATURES.OPPOSING_PARTY) && (
            <OpposingPartyRecapContainer
              isManager
              claimToPreopen={EMPTY_CLAIM_TO_PREOPEN}
              storedClaimToPreopen={props.claimRecap}
              listings={props.listings}
              policyInfo={props.policyInfo}
              setClaimRecap={props.setClaimRecap}
              requestCreateVehicle={props.requestCreateVehicle}
              requestValidateVehicle={props.requestValidateVehicle}
              requestUpdateVehicleInfo={props.requestUpdateVehicleInfo}
              setDataClaimToUpdate={props.setDataClaimToUpdate}
              dataClaimToUpdate={props.dataClaimToUpdate}
              sagisOpposingParties={extractOpposingParties(
                get(resolveSagisClaim(props.policyInfo), 'offeredRisks', []),
              )}
              requestClaimRecap={props.requestClaimRecap}
              claimId={props.match.params.claimId as any}
            />
          )}
          {get(props.claimRecap, 'claim.status') !== CLAIM_STATUS.VALIDATED ? (
            <ClaimCircumstances
              isRecapPage
              isManager
              isReadOnly={false}
              inputProps={{ disableUnderline: true }}
              disableInput
              inputLabelProps
              listings={props.listings}
              claimToPreopen={EMPTY_CLAIM_TO_PREOPEN}
              storedClaimToPreopen={props.claimRecap}
              setClaimRecap={props.setClaimRecap}
              claimCircumstancesSagis={get(
                resolveSagisClaim(props.policyInfo),
                'offeredRisks',
                [],
              )?.find(
                (element: { riskName: string }) =>
                  element.riskName === rcCoporeal,
              )}
            />
          ) : (
            <LawyerClaimCircumstances
              isRecapPage
              isReadOnly
              inputProps={{ disableUnderline: true }}
              inputLabelProps
              listings={props.listings}
              claimToPreopen={EMPTY_CLAIM_TO_PREOPEN}
              storedClaimToPreopen={props.claimRecap}
              setClaimRecap={props.setClaimRecap}
              setDataClaimToUpdate={props.setDataClaimToUpdate}
              dataClaimToUpdate={props.dataClaimToUpdate}
              isOpeningManager={userPrivileges.userHasPrivilege(
                PRIVILEGES.ISOPENINGMANAGER,
              )}
            />
          )}
          <VictimCard
            isRecapPage
            isManager
            isReadOnly={false}
            disableInput
            listings={props.listings}
            claimToPreopen={EMPTY_CLAIM_TO_PREOPEN}
            storedClaimToPreopen={props.claimRecap}
            setClaimRecap={props.setClaimRecap}
            isOpeningManager={isOpeningManager()}
            policyInfo={props.policyInfo}
            requestUpdateVictimInfo={props.requestUpdateVictimInfo}
            requestValidateVictim={props.requestValidateVictim}
            requestCreateVictim={props.requestAddVictims}
            updateFilde={() => null}
            setDataClaimToUpdate={props.setDataClaimToUpdate}
            dataClaimToUpdate={props.dataClaimToUpdate}
            requestClaimRecap={props.requestClaimRecap}
          />
          <UploadDocumentsBloc
            storedClaimToPreopen={props.claimRecap}
            isManager
            isRecap
            isReadOnly={false}
            index={0}
            resetUploadedDocument={props.resetUploadDocumentStore}
            uploadDocument={props.uploadDocument}
            uploadedDocument={props.uploadedDocument}
            setDocumentId={props.setDocumentId}
            docId={props.documentId}
            pvDocument={updatedPVDocument}
            setPVDocument={setPVDocument}
            deletePVDocument={deletePVDocument}
            setDataClaimToUpdate={props.setDataClaimToUpdate}
            dataClaimToUpdate={props.dataClaimToUpdate}
            setDocument={setDocument}
            requestGetReportsPolicy={props.requestGetReportsPolicy}
            requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
          />
          {featureService.hasFeature(FEATURES.FRAUDE_CORPO) && (
            <FraudeInformation
              isRecapPage
              updateFilde={() => null}
              storedClaimToPreopen={props.claimRecap}
              claimToPreopen={EMPTY_CLAIM_TO_PREOPEN}
              setDataClaimToUpdate={props.setDataClaimToUpdate}
              dataClaimToUpdate={props.dataClaimToUpdate}
              listings={props.listings}
              setClaimRecap={props.setClaimRecap}
              claimRecap={props.claimRecap}
            />
          )}
          {featureService.hasFeature(
            FEATURES.UPDATE_VALIDATED_CLAIM_OPENING_MANAGER,
          ) &&
            userPrivileges.userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER) &&
            get(props.claimRecap, 'claim.status') ===
              PROCEDURE_STATUSES.VALIDATED && (
              <PrimaryButton
                background={BUTTON_COLORS.PRIMARY_BLUE}
                border={BUTTON_COLORS.PRIMARY_BLUE}
                titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
                title={translate(messages.validationButtonTitle, props)}
                onClick={() => {
                  props.requestUpdateClaim &&
                    props.requestUpdateClaim(
                      {
                        ...props.dataClaimToUpdate,
                        claim: {
                          ...get(props.dataClaimToUpdate, 'claim'),
                          priorityReasonId: addPriorityReasonProfession(
                            priorityReasonClaimId,
                            !!removeRejectedVictims(
                              get(props.claimRecap, 'victims', []),
                            ).find((v: any) =>
                              PROFESSION_CODES.includes(v.professionCode),
                            ),
                            props.listings,
                          )
                            ? addPriorityReasonProfession(
                                priorityReasonClaimId,
                                !!removeRejectedVictims(
                                  get(props.claimRecap, 'victims', []),
                                ).find((v: any) =>
                                  PROFESSION_CODES.includes(v.professionCode),
                                ),
                                props.listings,
                              )
                            : updatePriorityVictim && priorityReasonClaimId != 4
                            ? null
                            : undefined,
                        },
                        driver: !isEmpty(get(props.dataClaimToUpdate, 'driver'))
                          ? {
                              ...get(props.dataClaimToUpdate, 'driver'),
                              isDriverTheInsured:
                                get(
                                  props.dataClaimToUpdate,
                                  'driver.isDriverTheInsured',
                                ) === CHOICE.NO
                                  ? false
                                  : Boolean(
                                      get(
                                        props.dataClaimToUpdate,
                                        'driver.isDriverTheInsured',
                                      ),
                                    ),
                            }
                          : {},
                        isLawyer: false,
                        victimsSagisToAdd: [...formattedSagisVictims],
                        victimsSagisToUpdate: [
                          ...formattedSagisVictimsToUpdate,
                        ],
                        isTrackingActive: featureService.hasFeature(
                          FEATURES.TRACKING_ACTIONS_USER,
                        ),
                        claimCircumstances: {
                          scaleCaseCode: get(
                            props.dataClaimToUpdate,
                            'claim.scaleCaseKey',
                            {},
                          ),
                          circumstanceCode: get(
                            props.dataClaimToUpdate,
                            'claim.accidentCirconstanceKey',
                            {},
                          ),
                          responsabilityRate: get(
                            props.dataClaimToUpdate,
                            'claim.responsabilityKey',
                            {},
                          ),
                          managementMode: MANAGEMENT_MODES.COMMON_RIGHT,
                          riskId,
                          isFromCorporel: true,
                        },
                        beneficiariesToDelete,
                        opposingPartiesSagisToAdd: formatOpposingParties(
                          get(props.dataClaimToUpdate, 'vehicules', []).filter(
                            (v: any) => !v.isDeleted && !v.id,
                          ),
                          riskId,
                          getClaimNumber(),
                          props.claimId as any,
                          get(props.listings, 'compagnies'),
                        ),
                        opposingPartiesSagisToUpdate: formattedSagisVehiculesToUpdate,
                        riskKey: riskId,
                        claimNumber: get(
                          props.dataClaimToUpdate,
                          'claim.claimNumber',
                        ),
                      },
                      props.claimId,
                      successCallback,
                    );
                }}
                className="validationButton"
              />
            )}
        </Container>
      )}
      <ProvisionIntervenantDialog
        open={isProvisionIntervenantDialogOpen}
        onClose={setIsProvisionIntervenantDialogOpen}
        intervenants={provisionIntervenants}
        listings={props.listings}
        requestValidateProvisionIntervenant={
          props.requestValidateProvisionIntervenant
        }
        riskId={riskId}
        claimId={props.claimId}
      />
    </GlobalBloc>
  );
};

export default ClaimRecap;
